import React from 'react';

export const GLYPHS = {
  ALERT: {
    id: 'ALERT',
    viewBox: '0 0 100 100',
    data: (
      <svg height="100" width="100" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M50 1C22.938 1 1 22.938 1 50s21.938 49 49 49 49-21.938 49-49S77.062 1 50 1zm0 82.709a7.54 7.54 0 1 1 0-15.08 7.54 7.54 0 0 1 0 15.08zm7.54-28.412a7.541 7.541 0 0 1-15.08 0V23.831a7.54 7.54 0 0 1 15.08 0v31.466z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  ARROW_RIGHT: {
    id: 'ARROW_RIGHT',
    viewBox: '0 0 7 12',
    data: (
      <svg width="7" height="12" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M.29 9.88L4.17 6 .29 2.12A.996.996 0 1 1 1.7.71L6.29 5.3c.39.39.39 1.02 0 1.41L1.7 11.3a.996.996 0 0 1-1.41 0c-.38-.39-.39-1.03 0-1.42z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </svg>
    ),
  },
  ARROW_LEFT: {
    id: 'ARROW_LEFT',
    viewBox: '0 0 7 12',
    data: (
      <svg width="7" height="12" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.71 9.88L2.83 6l3.88-3.88A.996.996 0 1 0 5.3.71L.71 5.3a.996.996 0 0 0 0 1.41L5.3 11.3c.39.39 1.02.39 1.41 0 .38-.39.39-1.03 0-1.42z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </svg>
    ),
  },
  CHECKBOX: {
    id: 'CHECKBOX',
    viewBox: '0 0 15 11',
    data: (
      <svg width="15" height="11" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.5 8.475L1.608 5.583A.83.83 0 1 0 .433 6.758l3.484 3.484a.83.83 0 0 0 1.175 0l8.816-8.817A.83.83 0 1 0 12.733.25L4.5 8.475z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </svg>
    ),
  },
  DOG: {
    id: 'DOG',
    viewBox: '0 0 90 33',
    data: (
      <svg width="90" height="33" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <path
            d="M80.296 32.07s-2.105.979-5.486.934c-3.38-.044-4.013-.935-4.013-.935s-2.073-.11-3.053-.252c0 0-21.2.938-39.61-.311l-11.095-1.012-1.701.087a15.65 15.65 0 0 1-1.685-.01L5 30.007l74.471.165c.503-.03 3.137.066 7.901.285 5.68.262 1.618 1.705-7.076 1.614z"
            fillOpacity=".3"
            fill="#000"
          />
          <path
            d="M12.046 29.249C7.459 30.696 1.893 30.557.583 30.418c-1.311-.14 0-1.73 0-1.73l6.29-4.67a1.379 1.379 0 0 1 1.5-.093l1.513.853 9.636-5.278L25 22.023"
            fill="#A36850"
          />
          <path
            d="M84.945 30.5c-.029-1.371 2.877-7.215 1.826-8.082-.822-.678-1.308-2.39-1.401-4.552-.267-4.986-4.704-8.92-12.537-8.011 0 0-1.896-9.783-4.941-9.34-3.046.443-3.616 9.35-3.616 9.35s-1.868 1.097-2.75 2.51c0 0-19.1-9.368-35.685 3.116 0 0-5.222-.872-6.815 2.497-1.592 3.37 2.471 3.068 2.471 3.068l-5.652 4.548-1.532-.872a1.39 1.39 0 0 0-1.518.094L5 30.481l42.438-.09"
            fill="#CA8C6E"
          />
          <path
            d="M41.894 9.235c-2.733.194-5.863.996-8.646 2.104-1.784.711-3.33 1.55-4.854 2.428-.976 2.737-.638 5.733 4.324 5.733 6.008.005 9.098-6.806 9.176-10.265zM79.757 30.5c3.776.085 9.325 1.06 9.242-3.913a4.345 4.345 0 0 0-1.407-3.277c-.269-.235-.505-.54-.74-.811-.338-.392-.65-.77-.852-1.233-.54-.146-1.02-.246-1.58-.266-3.266 0-6.424 2.692-6.42 6.074-.024 2.04.286 2.326 1.757 3.426z"
            fill="#A36850"
          />
          <path d="M79 17.5s1.64 2.25 3 0" stroke="#A36850" strokeWidth="1" strokeLinecap="round" />
          <path
            d="M87.301 23.039c-.217 0-.21.002-.406.08-.82.413-1.129 1.294-.706 2.02.423.726 1.433 1.052 2.315.747.195-.083.25-.143.38-.291-.029-.484-.233-1.188-.927-1.976-.113-.128-.331-.322-.656-.58z"
            fill="#092F68"
          />
          <path
            d="M68.099.5c-.1 2.428-.084 8.602 1.259 9.355.632.353 1.791.353 3.475 0-.619-3.01-1.399-5.4-2.341-7.171-.397-.746-.44-.885-1.289-1.72-.354-.35-.77-.4-1.104-.464zM58.467 25.366c3.96 0 7.829 1.348 9.404 2.403 1.452.967 1.61 2.731-.155 2.731H51.188a3.231 3.231 0 0 1-2.547-1.221 2.97 2.97 0 0 1-.516-2.692l1.575-5.231s2.58-8.754 9.463-6.478c5.348 1.764-.696 10.488-.696 10.488z"
            fill="#A36850"
          />
        </g>
      </svg>
    ),
  },
  DRAG_INDICATOR: {
    id: 'DRAG_INDICATOR',
    viewBox: '0 0 24 24',
    data: (
      <svg height="24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  DUPLICATE: {
    id: 'DUPLICATE',
    viewBox: '0 0 16 16',
    data: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M5,3.9973917 C5,2.89426272 5.89585781,2 6.9973917,2 L12.0026083,2 C13.1057373,2 14,2.89585781 14,3.9973917 L14,9.0026083 C14,10.1057373 13.1041422,11 12.0026083,11 L6.9973917,11 C5.89426273,11 5,10.1041422 5,9.0026083 L5,3.9973917 Z M2,12.0026083 L2,5.99754465 C2,5.4463114 2.44771525,5 3,5 C3.55613518,5 4,5.44902676 4,6.00292933 L4,10.4983244 C4,11.3288106 4.67232308,12 5.50167562,12 L9.99707067,12 C10.5621186,12 11,12.4477153 11,13 C11,13.5561352 10.553384,14 10.0024554,14 L3.9973917,14 C2.89585781,14 2,13.1057373 2,12.0026083 Z"
        />
      </svg>
    ),
  },
  EDIT: {
    id: 'EDIT',
    viewBox: '0 0 16 16',
    data: (
      <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M.5 12.55v2.533c0 .234.183.417.417.417H3.45a.39.39 0 0 0 .292-.125l9.1-9.092-3.125-3.125L.625 12.25a.41.41 0 0 0-.125.3zm14.758-8.683a.83.83 0 0 0 0-1.175l-1.95-1.95a.83.83 0 0 0-1.175 0l-1.525 1.525 3.125 3.125 1.525-1.525z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </svg>
    ),
  },
  PRINTER: {
    id: 'PRINTER',
    viewBox: '0 0 485 485',
    data: (
      <svg xmlns="http://www.w3.org/2000/svg" width="485.212" height="485.212">
        <path
          d="M151.636 363.906h151.618v30.331H151.636zM121.312 30.327h242.595v60.651h30.321V30.327C394.229 13.595 380.666 0 363.907 0H121.312c-16.748 0-30.327 13.595-30.327 30.327v60.651h30.327V30.327zM151.636 303.257h181.939v30.327H151.636z"
          fill="currentColor"
        />
        <path
          d="M454.882 121.304H30.334c-16.748 0-30.327 13.591-30.327 30.324v181.956c0 16.759 13.579 30.321 30.327 30.321h60.651v90.98c0 16.764 13.579 30.326 30.327 30.326h242.595c16.759 0 30.321-13.562 30.321-30.326v-90.98h60.653c16.76 0 30.322-13.562 30.322-30.321V151.628c.001-16.733-13.561-30.324-30.321-30.324zm-90.975 333.582H121.312V272.93h242.595v181.956zm60.644-242.604c-16.76 0-30.322-13.564-30.322-30.327 0-16.731 13.562-30.327 30.322-30.327 16.765 0 30.331 13.595 30.331 30.327 0 16.762-13.567 30.327-30.331 30.327z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  SEND_BACK: {
    id: 'SEND_BACK',
    viewBox: '0 0 16 16',
    data: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <path
          fill="currentColor"
          d="M3.36 4.41456V8.64C3.36 10.8491 5.15086 12.64 7.36 12.64H11.5854C11.2791 14.5449 9.62766 16 7.63636 16H4C1.79086 16 0 14.2091 0 12V8.36363C0 6.3723 1.45509 4.72089 3.36 4.41456Z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5 4V7.63636C14.5 9.01708 13.3807 10.1364 12 10.1364H8.36364C6.98293 10.1364 5.86364 9.01708 5.86364 7.63636V4C5.86364 2.61929 6.98293 1.5 8.36364 1.5H12C13.3807 1.5 14.5 2.61929 14.5 4ZM16 7.63636C16 9.8455 14.2091 11.6364 12 11.6364H8.36364C6.1545 11.6364 4.36364 9.8455 4.36364 7.63636V4C4.36364 1.79086 6.1545 0 8.36364 0H12C14.2091 0 16 1.79086 16 4V7.63636Z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.68315 4.82532L7.26054 7.7837C7.18055 8.34362 7.56493 8.71833 8.11636 8.63955L11.0747 8.21692C11.6248 8.13834 11.7473 7.75931 11.3571 7.36909L10.6506 6.66254L12.5564 4.75668C12.9493 4.36378 12.9465 3.73394 12.5563 3.34372C12.1633 2.95078 11.5335 2.95344 11.1433 3.34358L9.23751 5.24944L8.53097 4.54289C8.13804 4.14995 7.76118 4.27912 7.68315 4.82532Z"
        />
      </svg>
    ),
  },
  SEND_FORWARD: {
    id: 'SEND_FORWARD',
    viewBox: '0 0 16 16',
    data: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <path
          fill="currentColor"
          d="M3.36 4.41456C1.45509 4.72089 0 6.37234 0 8.36364V12C0 14.2091 1.79086 16 4 16H7.63636C9.62766 16 11.2791 14.5449 11.5854 12.64H10.0537C9.77098 13.7106 8.79586 14.5 7.63636 14.5H4C2.61929 14.5 1.5 13.3807 1.5 12V8.36364C1.5 7.20414 2.28935 6.22902 3.36 5.94631V4.41456Z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 7.63636C16 9.8455 14.2091 11.6364 12 11.6364H8.36364C6.1545 11.6364 4.36364 9.8455 4.36364 7.63636V4C4.36364 1.79086 6.1545 0 8.36364 0H12C14.2091 0 16 1.79086 16 4V7.63636ZM12.8395 3.91629L12.4169 6.87467C12.3388 7.42087 11.962 7.55004 11.569 7.1571L10.8625 6.45055L8.95667 8.35641C8.56654 8.74655 7.93667 8.74921 7.54374 8.35628C7.15353 7.96606 7.1507 7.33622 7.5436 6.94331L9.44942 5.03746L8.74289 4.3309C8.35268 3.94069 8.47525 3.56165 9.02531 3.48307L11.9836 3.06045C12.5351 2.98167 12.9195 3.35638 12.8395 3.91629Z"
        />
      </svg>
    ),
  },
  SEND_ALL_THE_WAY_FORWARD: {
    id: 'SEND_ALL_THE_WAY_FORWARD',
    viewBox: '0 0 16 16',
    data: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <path
          fill="currentColor"
          d="M10.0111 14C9.59927 15.1652 8.48804 16 7.18182 16H3C1.34315 16 0 14.6569 0 13V8.81819C0 7.51196 0.834806 6.40073 2 5.98889V7.70014C1.69312 7.97479 1.5 8.37394 1.5 8.81819V13C1.5 13.8284 2.17157 14.5 3 14.5H7.18182C7.62607 14.5 8.02521 14.3069 8.29987 14H10.0111Z"
        />
        <path
          fill="currentColor"
          d="M12.9416 11.18C12.4837 12.2512 11.4204 13.0018 10.1818 13.0018H6C4.34314 13.0018 3 11.6587 3 10.0018V5.82C3 4.58208 3.74978 3.51929 4.82 3.06098V4.89383C4.61955 5.14886 4.5 5.47046 4.5 5.82V10.0018C4.5 10.8302 5.17157 11.5018 6 11.5018H10.1818C10.5324 11.5018 10.8549 11.3815 11.1103 11.18H12.9416Z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 7.18182C16 8.83867 14.6569 10.1818 13 10.1818H8.81818C7.16133 10.1818 5.81818 8.83867 5.81818 7.18182V3C5.81818 1.34315 7.16133 0 8.81818 0H13C14.6569 0 16 1.34315 16 3V7.18182ZM13.2345 3.42676L12.8647 6.01534C12.7965 6.49327 12.4667 6.60629 12.1229 6.26247L11.5047 5.64424L9.83709 7.31186C9.49572 7.65323 8.94458 7.65556 8.60077 7.31174C8.25934 6.9703 8.25686 6.41919 8.60065 6.0754L10.2682 4.40777L9.65003 3.78954C9.30859 3.4481 9.41585 3.11645 9.89715 3.04769L12.4857 2.67789C12.9682 2.60896 13.3045 2.93683 13.2345 3.42676Z"
        />
      </svg>
    ),
  },
  SEARCH: {
    id: 'SEARCH',
    viewBox: '0 0 16 16',
    data: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
        <path
          fill="currentColor"
          d="M6.1485,10.2969 C4.1335,10.2969 2.5005,8.6639 2.5005,6.6489 C2.5005,4.6339 4.1335,2.9999 6.1485,2.9999 C8.1635,2.9999 9.7965,4.6339 9.7965,6.6489 C9.7965,8.6639 8.1635,10.2969 6.1485,10.2969 M14.2075,12.6429 L11.0995,9.7069 C11.0555,9.6629 10.9995,9.6419 10.9505,9.6079 C11.4835,8.7459 11.7965,7.7339 11.7965,6.6489 C11.7965,3.5339 9.2635,0.9999 6.1485,0.9999 C3.0335,0.9999 0.5005,3.5339 0.5005,6.6489 C0.5005,9.7629 3.0335,12.2969 6.1485,12.2969 C7.1495,12.2969 8.0885,12.0329 8.9045,11.5739 C8.9455,11.6409 8.9765,11.7129 9.0355,11.7709 L12.1435,14.7069 C12.5335,15.0979 13.1665,15.0979 13.5575,14.7069 L14.2075,14.0569 C14.5975,13.6669 14.5975,13.0339 14.2075,12.6429"
        />
      </svg>
    ),
  },
  SETTINGS: {
    id: 'SETTINGS',
    viewBox: '0 0 32 29',
    data: (
      <svg width="32" height="29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.535 28.006h14.93a1.078 1.078 0 00.926-.539l7.465-12.925a1.078 1.078 0 000-1.078L24.39.54A1.077 1.077 0 0023.465 0H8.535a1.077 1.077 0 00-.926.539L.144 13.464a1.077 1.077 0 000 1.078L7.61 27.467a1.076 1.076 0 00.926.539zm4.687-9.843a5 5 0 105.556-8.314 5 5 0 00-5.556 8.314zm1.39-6.236a2.5 2.5 0 112.777 4.157 2.5 2.5 0 01-2.778-4.157z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  REMOVE: {
    id: 'REMOVE',
    viewBox: '0 0 14 14',
    data: (
      <svg width="14" height="14" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.3.71a.996.996 0 0 0-1.41 0L7 5.59 2.11.7A.996.996 0 1 0 .7 2.11L5.59 7 .7 11.89a.996.996 0 1 0 1.41 1.41L7 8.41l4.89 4.89a.996.996 0 1 0 1.41-1.41L8.41 7l4.89-4.89c.38-.38.38-1.02 0-1.4z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </svg>
    ),
  },
  UPLOAD: {
    id: 'UPLOAD',
    viewBox: '0 0 18 20',
    data: (
      <svg width="18" height="20" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 9v8a2.995 2.995 0 0 0 1.853 2.773c.354.146.742.227 1.147.227h12a2.995 2.995 0 0 0 2.773-1.853c.146-.354.227-.742.227-1.147V9a1 1 0 0 0-2 0v8a.997.997 0 0 1-1 1H3a.997.997 0 0 1-1-1V9a1 1 0 0 0-2 0zm8-5.586V14a1 1 0 0 0 2 0V3.414l2.293 2.293a.999.999 0 1 0 1.414-1.414l-4-4-.004-.004a.996.996 0 0 0-1.406 0l-.004.004-4 4a.999.999 0 1 0 1.414 1.414L8 3.414z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </svg>
    ),
  },
  TRASH_CAN: {
    id: 'TRASH_CAN',
    viewBox: '0 0 12 16',
    data: (
      <svg width="12" height="16" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1 13.833c0 .917.75 1.667 1.667 1.667h6.666c.917 0 1.667-.75 1.667-1.667V5.5c0-.917-.75-1.667-1.667-1.667H2.667C1.75 3.833 1 4.583 1 5.5v8.333zm10-12.5H8.917L8.325.742A.84.84 0 0 0 7.742.5H4.258a.84.84 0 0 0-.583.242l-.592.591H1a.836.836 0 0 0-.833.834C.167 2.625.542 3 1 3h10a.836.836 0 0 0 .833-.833.836.836 0 0 0-.833-.834z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </svg>
    ),
  },
  WARNING: {
    id: 'WARNING',
    viewBox: '0 0 30 30',
    data: (
      <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg">
        <g fill="#FFF" fillRule="nonzero">
          <path d="M15 30c8.267 0 15-6.733 15-15S23.267 0 15 0 0 6.733 0 15s6.733 15 15 15zm0-27.907c7.116 0 12.907 5.79 12.907 12.907 0 7.116-5.79 12.907-12.907 12.907-7.116 0-12.907-5.79-12.907-12.907C2.093 7.884 7.883 2.093 15 2.093z" />
          <path d="M15 18.14c.593 0 1.047-.454 1.047-1.047V9.07c0-.593-.454-1.047-1.047-1.047s-1.047.454-1.047 1.047v8.023c0 .593.454 1.047 1.047 1.047zM15 21.977a1.4 1.4 0 0 0 1.395-1.396A1.4 1.4 0 0 0 15 19.186a1.4 1.4 0 0 0-1.395 1.395A1.4 1.4 0 0 0 15 21.977z" />
        </g>
      </svg>
    ),
  },
};
